import React, { useEffect } from 'react';
import { Chip, FormControl, Input, InputLabel, MenuItem, Select } from "@material-ui/core";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import "./CustomMultiselect.css"
import { formatCustomerResponse } from '../../../utils/handleData';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: "8px 0",
        minWidth: 120,
        maxWidth: 516,
        width: "100%",
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
        maxWidth: '254px',
        textWrap: 'wrap',
        height: 'auto'
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: "100%",
        },
    },
};

function getStyles(option, selectedOptions, theme) {
    return {
        fontWeight:
            selectedOptions?.indexOf(option) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
        textWrap: "wrap"
    };
}


const CustomMultiselect = ({ question, label, updateResponse, customerResponse }) => {
    const classes = useStyles();
    const theme = useTheme();
    const [selectedOptions, setSelectedOptions] = React.useState(customerResponse ? formatCustomerResponse(customerResponse) : []);
    const options = question.qstOpt

    useEffect(() => {
        if(question?.display === "none") {
            setSelectedOptions([])
        }
    }, [question.display])

    const handleChange = (event) => {
        if(event.target.value.some((el) => el.toLowerCase() === "none")) {
            setSelectedOptions(["None"]);
            updateResponse("None", question, "multipleSelection")
        } else {
            setSelectedOptions(event.target.value);
            updateResponse(event.target.value.join(","), question, "multipleSelection")
        }
    };
    
    return (
        <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-mutiple-chip-label">{label}</InputLabel>
            <Select
                labelId="demo-mutiple-chip-label"
                id="demo-mutiple-chip"
                multiple
                value={selectedOptions}
                onChange={handleChange}
                input={<Input id="select-multiple-chip" />}
                renderValue={(selected) => (
                    <div className={classes.chips}>
                        {selected.map((value) => (
                            <Chip key={value} label={value} className={classes.chip} />
                        ))}
                    </div>
                )}
                MenuProps={MenuProps}
                inputProps={{
                    disableUnderline: true,
                  }}
            >
                {options.map((option) => (
                    <MenuItem key={option} value={option} style={getStyles(option, selectedOptions, theme)}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default CustomMultiselect;